import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/styles.css'
import './assets/css/responsive.css'
import './assets/css/fonts.css'
import './assets/css/app.css'
import Layout from "./components/Layout";
import {
    Routes,
    Route
} from "react-router-dom";
import React from "react";
import Home from "./routes/home";
import AboutUs from "./routes/home/about-us";
import Admin from "./routes/admin";
import AuthSas from "./routes/authsas";
import {RedirectAuth, RequireAuth} from "./utils/common";
import { ToastContainer } from 'react-toastify';
import {getAccessToken} from "./utils/authority";
import PublicSecureUser from "./services/system/user/secure-user-controller";
import DeleteAccount from "./routes/delete-account";
import Privacy from "./routes/privacy";
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuth: false
        }
    }
    UNSAFE_componentWillMount() {
        let token = getAccessToken();
        this.setState({isAuth: !!token});
        PublicSecureUser.allPermission(res => {
            if (res.success) {
                // console.log("List All Quyền")
                // console.log(res.data)
            } else {
            }
        });
        let version = React.version
        console.log("Version ReactJs", version)
    }
    render() {
        return (
            <Layout>
                <Routes>
                    {/*<Route path="/" element={<HomePage/>}/>*/}
                    <Route
                        path="/"
                        element={
                            <RequireAuth redirectTo="/dang-nhap">
                                <Admin />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/ad-sas-school/*"
                        element={
                            <RequireAuth redirectTo="/dang-nhap">
                                <Admin />
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="/dang-nhap"
                        element={
                            <RedirectAuth redirectTo="/ad-sas-school">
                                <AuthSas />
                            </RedirectAuth>
                        }
                    />
                    <Route
                        path="/dang-nhap"
                        element={
                            <RedirectAuth redirectTo="/ad-sas-school">
                                <AuthSas />
                            </RedirectAuth>
                        }
                    />
                    <Route path="/home/*" element={<Home/>}/>
                    <Route path="/yeu-cau-xoa-tai-khoan" element={<DeleteAccount/>}/>
                    <Route path="/privacy" element={<Privacy/>}/>
                </Routes>
                <ToastContainer />
            </Layout>
        );
    }
}
export default  App;
